import { GrantSlackAccessMutationfs5xfcp7iisz as GrantSlackAccessMutation } from './schema/GrantSlackAccessMutation.mjs';
import {
  Unauthorized_instancena1wy93qjp67 as Unauthorized_instance,
  Accepted_instance2n0ntuorxhisv as Accepted_instance,
  Rejected_instance3ro33n8adnov1 as Rejected_instance,
} from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatchervu4hb3oerxrm as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantSlackAccessCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GrantSlackAccessInput3j0s7of1xul8d as GrantSlackAccessInput } from './schema/type/GrantSlackAccessInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  var tmp0_safe_receiver = (yield* this.a6u(new (GrantSlackAccessMutation())(grantSlackAccessInput(command)), $completion)).d42_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a6g_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toVoidResult(tmp1_safe_receiver);
  return tmp2_elvis_lhs == null ? Unauthorized_instance : tmp2_elvis_lhs;
}
var SdkGrantSlackAccessClass;
function SdkGrantSlackAccess() {
  if (SdkGrantSlackAccessClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkGrantSlackAccess', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkGrantSlackAccessClass = $;
  }
  return SdkGrantSlackAccessClass;
}
function toVoidResult(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4) {
    case true:
      tmp = Accepted_instance;
      break;
    case false:
      tmp = Rejected_instance;
      break;
    case null:
      tmp = Unauthorized_instance;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function grantSlackAccessInput(_this__u8e3s4) {
  return new (GrantSlackAccessInput())(_this__u8e3s4.a2j_1, _this__u8e3s4.b2j_1);
}
//region block: exports
export {
  SdkGrantSlackAccess as SdkGrantSlackAccess15ga4e1z55nsr,
  toVoidResult as toVoidResult8ga34bq1f52r,
  perform as perform8stx2d3k0qmh,
};
//endregion

//# sourceMappingURL=SdkGrantSlackAccess.mjs.map
